<div class="diagram-container">
  <button
    [class]="'bar-container'"
    [class.selected]="selectedState() === ECalculusStateFilter.onHold">
    <div
      class="single-bar">
      <div
        class="bar"
        [style.width.%]="_evaluationData[0]"
      ></div>

      <div class="label">
        {{ showPercentages() ? evaluationDisplayPercentages[0] : evaluationDisplayAbsolute[0] }}
      </div>
    </div>
  </button>
</div>
